import { openModal } from '@core/components/ModalStack';
import { DetailReportOverlayProps } from './DetailReportOverlay';
import { ReportBuilderOverlayProps } from './ReportBuilderOverlay';
import { ReportOverlayProps } from './ReportOverlay';

export async function openReportBuilderOverlay(props: ReportBuilderOverlayProps) {
  const { ReportBuilderOverlay } = await import('./ReportBuilderOverlay');

  openModal(ReportBuilderOverlay, props);
}

export async function openReportOverlay(props: ReportOverlayProps) {
  const { ReportOverlay } = await import('./ReportOverlay');

  openModal(ReportOverlay, props);
}

export async function openDetailsReportOverlay(props: DetailReportOverlayProps) {
  const { DetailReportOverlay } = await import('./DetailReportOverlay');

  openModal(DetailReportOverlay, props);
}
